import { useCallback } from 'react';

import { useDeleteMessage } from '@web/conversations/hooks/useDeleteMessage';
import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';

type ID = number;
type Props = {
  conversationId: ID;
  messageId: ID;
};

export const useDeleteMessageAction = () => {
  const { removeMessage } = useConversationActions();
  const mutation = useDeleteMessage();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async (payload: Props) => {
      removeMessage({
        messageId: payload.messageId,
      });

      try {
        await mutateAsync({
          conversationId: payload.conversationId,
          messageId: payload.messageId,
        });
      } finally {
        // INFO we don't care about the result for some reason ;)
      }
    },
    [mutateAsync, removeMessage]
  );

  return { action, mutation };
};
